<mat-card *ngIf="order && documents">
  <div fxLayout="row" fxLayoutAlign="center start">
    <a mat-icon-button class="back" routerLink="/digitar/{{order.id}}">
      <mat-icon>arrow_back</mat-icon>
    </a>
    <div fxFlex>
      <mat-card-title fxLayout="row">
        <div fxFlex="30">Órden: {{order.id}} Línea: {{order.items[0].line}}</div>
        <div fxFlex>Fecha de publicación:
          <span *ngFor="let dt of order.items[0].publishDates">{{dt | date: 'MMM dd yyyy '}}</span>
        </div>
        <div>Estado: {{order.internalStatus}}</div>
      </mat-card-title>
      <mat-card-subtitle fxLayout="row">
        <div fxFlex="30">Cliente: {{order.clientName}} - ({{order.nit}})</div>
        <div fxFlex>Notas: {{order.items[0].notes}}</div>
        <div>Cantidad: {{order.items[0].quantity}}</div>
      </mat-card-subtitle>
    </div>
  </div>
  <mat-card-content>
    <mat-tab-group (selectedTabChange)="onChangeTab($event)">
      <mat-tab *ngFor="let doc of documents" label="Documento {{doc.index}}">
        <div class="tab-content">
          <div class="type-control">
            <app-type-control *ngFor="let data of doc.data" [isActive]="activeIndex === doc.index" [documentData]="data" [orderDocument]="doc"
              [disabled]="doc.isSaved || isPastItem" [subscription]="subscription"></app-type-control>
            <div *ngIf="doc.status !== 'PU' && !isPastItem" fxLayout="row">
              <div fxFlex></div>
              <button align="end" mat-raised-button color="primary" *ngIf="!doc.isSaved" (click)="saveOrder(doc)">Guardado definitivo</button>
              <button align="end" mat-raised-button *ngIf="doc.isSaved" (click)="cancelSave(doc)">Corregir digitación</button>
            </div>
          </div>
          <mat-accordion [multi]="true">
            <!-- <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                Contenido
              </mat-expansion-panel-header>

            </mat-expansion-panel> -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                OCR
              </mat-expansion-panel-header>
              <app-ocr-control></app-ocr-control>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
